import {Component, OnDestroy, OnInit} from '@angular/core';
import {ColumnComponent} from "@Common/widgets/general/data-table";
import {SubSink} from "@Common/core/utils/subsink";
import {Document} from "../../../services/document/document.model";
import {ModaleBoxComponent} from "../../modales/box/modale-box.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-box-detail',
  template: ` <span style="text-decoration: underline;cursor: pointer;" (click)="openModal()">
    Boîte n° {{input.box_obj.box_number.toString()}}
  </span>`,
})
export class BoxDetailComponent implements ColumnComponent,  OnInit, OnDestroy {
  column: string;
  data: any;
  input: Document;
  name: string;
  loading = false;
  subSink = new SubSink();
  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  openModal(): void {
    const data = this.input;
    const dialogRef = this.dialog.open(ModaleBoxComponent, { data: data });
    dialogRef.updateSize('800px');
    dialogRef.updatePosition({top: '100px'});
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
